module.exports = __webpack_public_path__ + "img/WEILINGTON_background.d12fafd5.png";